module.exports = __webpack_public_path__ + "static/media/settings.01f553fe.svg";